export enum IconWithContentBlock {
  Root = 'IconWithContent',
}

export enum IconWithContentModifier {
  Reversed = 'reversed',
}
